import type React from 'react'

type SpeakToKitThemeVarKey =
    | '--background'
    | '--foreground'
    | '--card'
    | '--card-foreground'
    | '--popover'
    | '--popover-foreground'
    | '--primary'
    | '--primary-foreground'
    | '--secondary'
    | '--secondary-foreground'
    | '--muted'
    | '--muted-foreground'
    | '--accent'
    | '--accent-foreground'
    | '--destructive'
    | '--destructive-foreground'
    | '--border'
    | '--input'
    | '--ring'
    | '--radius'
    | '--shadow-soft'
    | '--shadow-card'

type SpeakToKitThemeVars = React.CSSProperties &
    Record<SpeakToKitThemeVarKey, string>

export const speakToKitThemeVars: SpeakToKitThemeVars = {
    '--background': '30 37% 97%',
    '--foreground': '27 30% 13%',
    '--card': '30 33% 94%',
    '--card-foreground': '28 27% 12%',
    '--popover': '30 33% 94%',
    '--popover-foreground': '28 27% 12%',
    '--primary': '22 52% 51%',
    '--primary-foreground': '0 0% 100%',
    '--secondary': '29 53% 80%',
    '--secondary-foreground': '28 25% 20%',
    '--muted': '29 33% 90%',
    '--muted-foreground': '28 15% 35%',
    '--accent': '24 55% 62%',
    '--accent-foreground': '28 27% 12%',
    '--destructive': '0 65% 45%',
    '--destructive-foreground': '0 0% 100%',
    '--border': '27 25% 85%',
    '--input': '27 25% 85%',
    '--ring': '22 53% 51%',
    '--radius': '1.5rem',
    '--shadow-soft': '0 15px 45px -15px hsl(28 24% 30% / 0.25)',
    '--shadow-card': '0 25px 65px -30px hsl(28 24% 30% / 0.35)',
}

export const speakToKitSerifStyle: React.CSSProperties = {
    fontFamily: '"Playfair Display", serif',
}
